
import { Link } from 'react-router-dom'

function AmstelIdNav() {
  return (
    <Link to='/profile/identificacion' className="w-full shadow-lg" onClick={() => { gtag('event', 'event_to_ga', { event_category: 'navegacion_perfil', event_label: 'Home links' }) }}>
      <img src={`${AZURE_BASE_URL}/amstel-id.webp`} className='w-full' alt="" />
    </Link>
  )
}

export default AmstelIdNav